<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <CustomDeliveryDetailsForm />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import CustomDeliveryDetailsForm from '@/components/settings/integrador/custom-delivery-details/CustomDeliveryDetailsForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'CustomDeliveryDetailsEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    CustomDeliveryDetailsForm,
    LoadingPage
  }
}
</script>
